module.exports = __webpack_public_path__ + "img/hotels.d3bcc7b2.svg";